



































































































































































































































































































import { Component, Watch } from "vue-property-decorator";
import EveryTimeV4 from "./EveryTimeV4.vue";

@Component
export default class EveryTimeV5 extends EveryTimeV4 {
  //特別地域加算（算定結果のspecial_area_divに基づいてチェック、常にdisabled）
  protected get specialAreaValue(): number {
    return this.medicalSpecialAreaDiv >= 1 ? 1 : 0;
  }
  protected set specialAreaValue(_val: number) {
    // disabled のため変更不可
  }

  /** 機能強化区分4 */
  protected kinou_kyoka_div4 = false;

  created(): void {
    this.setTimesDiv();
    this.setKinouKyokaDivV3();
    this.setMentalSupportDiv();
    this.setLeaveSupportFlg();
    this.setSpecialInstFlg();
  }

  /** 特別管理指導（指導１）*/
  protected special_inst_flg1 = false;
  /** 特別管理指導（指導２） */
  protected special_inst_flg2 = false;

  // special_inst_flg 0:なし 1:指導１のみ 2:指導２のみ 3:指導１＋指導２
  protected setSpecialInstFlg() {
    const flg = this.receiptVisitRecord.special_inst_flg;
    this.special_inst_flg1 = flg == 1 || flg == 3;
    this.special_inst_flg2 = flg == 2 || flg == 3;
  }

  // 特別管理指導（指導１）
  @Watch("special_inst_flg1") protected handleSpecialInstFlg1() {
    if (!this.isLoaded) {
      return;
    }
    this.applySpecialInstFlg();
  }

  // 特別管理指導（指導２）
  @Watch("special_inst_flg2") protected handleSpecialInstFlg2() {
    if (!this.isLoaded) {
      return;
    }
    this.applySpecialInstFlg();
  }

  protected applySpecialInstFlg() {
    let flg = 0;
    if (this.special_inst_flg1 && this.special_inst_flg2) {
      flg = 3;
    } else if (this.special_inst_flg2) {
      flg = 2;
    } else if (this.special_inst_flg1) {
      flg = 1;
    }
    this.receiptVisitRecord.special_inst_flg = flg;
  }

  //機能強化区分
  protected setKinouKyokaDivV3() {
    if (this.receiptVisitRecord.kinou_kyoka_div == 1) {
      this.kinou_kyoka_div1 = true;
    }
    if (this.receiptVisitRecord.kinou_kyoka_div == 2) {
      this.kinou_kyoka_div2 = true;
    }
    if (this.receiptVisitRecord.kinou_kyoka_div == 3) {
      this.kinou_kyoka_div3 = true;
    }
    if (this.receiptVisitRecord.kinou_kyoka_div == 4) {
      this.kinou_kyoka_div4 = true;
    }
  }

  //機能強化区分4
  @Watch("kinou_kyoka_div4") protected handleKinouKyokaDiv4() {
    if (!this.isLoaded) {
      return;
    }
    if (this.kinou_kyoka_div4 == true) {
      this.receiptVisitRecord.kinou_kyoka_div = 4;
    }
    if (this.kinou_kyoka_div4 == false) {
      this.receiptVisitRecord.kinou_kyoka_div = 0;
    }
  }

  //提供時間 (早朝・夜間・深夜)
  protected disableCheckMedicalTimeZoneDivV2(): boolean {
    let result = false;
    if (
      this.baseDisableCheck() ||
      this.receiptVisitRecord.comprehensive_flg == 1 ||
      this.receiptVisitRecord.comprehensive_sub_flg == 1
    ) {
      result = true;
    }
    return result;
  }

  //複数回訪問:回数
  protected disableCheckTimesDivV4(): boolean {
    let result = false;
    if (
      (this.event.visit_record.mental_div == 2 &&
        this.officeHistory.medical_seishin_fukusukai_add == 0) ||
      this.receiptVisitRecord.comprehensive_flg == 1 ||
      this.receiptVisitRecord.comprehensive_sub_flg == 1 ||
      this.baseDisableCheck()
    ) {
      result = true;
    }
    return result;
  }

  //複数回訪問:同一建物内
  protected disableCheckTimesThreepersonDivV2(): boolean {
    let result = false;
    if (
      (this.event.visit_record.mental_div == 1 &&
        this.receiptVisitRecord.remedy_div != 2) ||
      (this.event.visit_record.mental_div == 2 &&
        this.receiptVisitRecord.remedy_div != 3) ||
      (this.event.visit_record.mental_div == 2 &&
        this.officeHistory.medical_seishin_fukusukai_add == 0) ||
      this.receiptVisitRecord.comprehensive_flg == 1 ||
      this.receiptVisitRecord.comprehensive_sub_flg == 1 ||
      this.baseDisableCheck()
    ) {
      result = true;
      this.receiptVisitRecord.times_threeperson_div = 1;
    }
    return result;
  }

  //複数名訪問:職員種別
  protected disableCheckAccompaniedStaffDivV2(): boolean {
    let result = false;
    if (
      this.baseDisableCheck() ||
      this.receiptVisitRecord.comprehensive_flg == 1 ||
      this.receiptVisitRecord.comprehensive_sub_flg == 1
    ) {
      result = true;
    }
    return result;
  }

  //複数名訪問:（ニ）（ハ）
  protected disableCheckAccompaniedHojoStaffDivV5(): boolean {
    let result = false;
    if (
      this.event.visit_record.mental_div == 2 ||
      this.receiptVisitRecord.accompanied_staff_div == 0 ||
      this.receiptVisitRecord.comprehensive_flg == 1 ||
      this.receiptVisitRecord.comprehensive_sub_flg == 1 ||
      this.baseDisableCheck()
    ) {
      result = true;
    }
    return result;
  }

  //複数名訪問:回数区分
  protected disableCheckAccompaniedStaffCntV5(): boolean {
    let result = false;
    if (
      this.receiptVisitRecord.accompanied_staff_div == 0 ||
      (this.event.visit_record.mental_div == 1 &&
        this.receiptVisitRecord.accompanied_hojo_staff_div != 2) ||
      (this.event.visit_record.mental_div == 2 &&
        (this.receiptVisitRecord.accompanied_staff_div == 4 ||
          this.receiptVisitRecord.accompanied_staff_div == 6 ||
          this.receiptVisitRecord.accompanied_staff_div == 7 ||
          this.receiptVisitRecord.accompanied_staff_div == 9)) ||
      this.baseDisableCheck() ||
      this.receiptVisitRecord.comprehensive_flg == 1 ||
      this.receiptVisitRecord.comprehensive_sub_flg == 1
    ) {
      result = true;
    }
    return result;
  }

  //複数名訪問:同一建物内
  protected disableCheckAccompaniedStaffThreepersonDivV2(): boolean {
    let result = false;
    if (
      (this.event.visit_record.mental_div == 1 &&
        this.receiptVisitRecord.remedy_div != 2) ||
      (this.event.visit_record.mental_div == 2 &&
        this.receiptVisitRecord.remedy_div != 3) ||
      this.baseDisableCheck() ||
      this.receiptVisitRecord.comprehensive_flg == 1 ||
      this.receiptVisitRecord.comprehensive_sub_flg == 1
    ) {
      result = true;
      this.receiptVisitRecord.accompanied_staff_threeperson_div = 1;
    }
    return result;
  }

  //機能強化型訪問看護管理療養費1
  protected disableCheckKinouKyokaDiv1V2(): boolean {
    let result = false;
    if (
      this.officeHistory.medical_kinou_kyoka_ryouyouhi1 == 0 ||
      this.receiptVisitRecord.comprehensive_flg == 1 ||
      this.receiptVisitRecord.comprehensive_sub_flg == 1
    ) {
      result = true;
    }
    return result;
  }

  //機能強化型訪問看護管理療養費2
  protected disableCheckKinouKyokaDiv2V2(): boolean {
    let result = false;
    if (
      this.officeHistory.medical_kinou_kyoka_ryouyouhi2 == 0 ||
      this.receiptVisitRecord.comprehensive_flg == 1 ||
      this.receiptVisitRecord.comprehensive_sub_flg == 1
    ) {
      result = true;
    }
    return result;
  }

  //機能強化型訪問看護管理療養費3
  protected disableCheckKinouKyokaDiv3V2(): boolean {
    let result = false;
    if (
      this.officeHistory.medical_kinou_kyoka_ryouyouhi3 == 0 ||
      this.receiptVisitRecord.comprehensive_flg == 1 ||
      this.receiptVisitRecord.comprehensive_sub_flg == 1
    ) {
      result = true;
    }
    return result;
  }

  //機能強化型訪問看護管理療養費4
  protected disableCheckKinouKyokaDiv4(): boolean {
    let result = false;
    if (
      this.officeHistory.medical_kinou_kyoka_ryouyouhi4 == 0 ||
      this.receiptVisitRecord.comprehensive_flg == 1 ||
      this.receiptVisitRecord.comprehensive_sub_flg == 1
    ) {
      result = true;
    }
    return result;
  }

  //夜間・早朝、深夜訪問:同一建物内(2026年6月法改正～)
  protected disableCheckMedicalTimeZoneSameBuildingDiv(): boolean {
    let result = false;
    if (
      this.receiptVisitRecord.medical_time_zone_div == 1 ||
      (this.event.visit_record.mental_div == 1 &&
        this.receiptVisitRecord.remedy_div != 2) ||
      (this.event.visit_record.mental_div == 2 &&
        this.receiptVisitRecord.remedy_div != 3) ||
      (this.event.visit_record.mental_div == 2 &&
        this.officeHistory.medical_seishin_fukusukai_add == 0) ||
      this.baseDisableCheck()
    ) {
      result = true;
      this.receiptVisitRecord.medical_time_zone_same_building_div = 1;
    }
    return result;
  }

  //複数回訪問:同一建物内(2026年6月法改正～)
  protected disableCheckTimesSameBuildingDiv(): boolean {
    let result = false;
    if (
      (this.event.visit_record.mental_div == 1 &&
        this.receiptVisitRecord.remedy_div != 2) ||
      (this.event.visit_record.mental_div == 2 &&
        this.receiptVisitRecord.remedy_div != 3) ||
      (this.event.visit_record.mental_div == 2 &&
        this.officeHistory.medical_seishin_fukusukai_add == 0) ||
      this.receiptVisitRecord.comprehensive_flg == 1 ||
      this.receiptVisitRecord.comprehensive_sub_flg == 1 ||
      this.baseDisableCheck()
    ) {
      result = true;
      this.receiptVisitRecord.times_same_building_div = 1;
    }
    return result;
  }

  //複数名訪問:同一建物内(2026年6月法改正～)
  protected disableCheckAccompaniedStaffSameBuildingDiv(): boolean {
    let result = false;
    if (
      (this.event.visit_record.mental_div == 1 &&
        this.receiptVisitRecord.remedy_div != 2) ||
      (this.event.visit_record.mental_div == 2 &&
        this.receiptVisitRecord.remedy_div != 3) ||
      this.receiptVisitRecord.comprehensive_flg == 1 ||
      this.receiptVisitRecord.comprehensive_sub_flg == 1 ||
      this.baseDisableCheck()
    ) {
      result = true;
      this.receiptVisitRecord.accompanied_staff_same_building_div = 1;
    }
    return result;
  }

  // 別表7該当判定（指示書別表7病名）
  protected isBeppyo7(): boolean {
    return (this.event.indicate?.diseases?.length ?? 0) > 0;
  }

  // 別表8該当判定（指示書別表8状態）
  protected isBeppyo8(): boolean {
    return (this.event.indicate?.states?.length ?? 0) > 0;
  }

  // 退院時共同指導日
  protected disableCheckMedicalLeaveInstDate(): boolean {
    let result = false;
    if (
      this.receiptVisitRecord.online_visit_flg == 1 ||
      this.receiptVisitRecord.medical_leave_inst_flg == 0 ||
      this.officeHistory.business_div == 3
    ) {
      result = true;
    }
    return result;
  }

  // 退院時共同指導日1（必須入力）
  protected isNeedMedicalLeaveInstDate1(): boolean {
    return (
      this.receiptVisitRecord.medical_leave_inst_flg > 0 &&
      this.officeHistory.business_div != 3
    );
  }

  // 退院時共同指導日1
  protected chackMedicalLeaveInstDate1(): boolean | string {
    if (this.disableCheckMedicalLeaveInstDate()) {
      return true;
    }
    //日にち被り不可
    if (
      this.receiptVisitRecord.medical_leave_inst_date != "" &&
      this.receiptVisitRecord.medical_leave_inst_date == this.receiptVisitRecord.medical_leave_inst_date2
    ) {
      return "退院時共同指導日に同日付が入力されています";
    }
    //訪問日当日以降不可（入院時に指導を行うため訪問日より前であること）
    const visitDay = this.event.visit_record.service_start_datetime.slice(0, 10);
    if (
      this.receiptVisitRecord.medical_leave_inst_date != "" &&
      this.receiptVisitRecord.medical_leave_inst_date >= visitDay
    ) {
      return "退院時共同指導日は訪問日より前の日付を入力してください";
    }
    return true;
  }

  // 退院時共同指導日2
  protected chackMedicalLeaveInstDate2(): boolean | string {
    //別表7/8非該当時は指導日2を表示しないためチェック不要
    if (
      this.disableCheckMedicalLeaveInstDate() ||
      !(this.isBeppyo7() || this.isBeppyo8())
    ) {
      return true;
    }
    //日にち被り不可
    if (
      this.receiptVisitRecord.medical_leave_inst_date != "" &&
      this.receiptVisitRecord.medical_leave_inst_date == this.receiptVisitRecord.medical_leave_inst_date2
    ) {
      return "退院時共同指導日に同日付が入力されています";
    }
    //訪問日当日以降不可（入院時に指導を行うため訪問日より前であること）
    const visitDay = this.event.visit_record.service_start_datetime.slice(0, 10);
    if (
      this.receiptVisitRecord.medical_leave_inst_date2 != "" &&
      this.receiptVisitRecord.medical_leave_inst_date2 >= visitDay
    ) {
      return "退院時共同指導日は訪問日より前の日付を入力してください";
    }
    return true;
  }

  // 特別管理指導 共通条件（別表8該当・特別管理加算あり・退院時共同指導算定が必須）
  protected disableCheckSpecialInstFlg(): boolean {
    let result = false;
    if (
      !this.isBeppyo8() ||
      this.officeHistory.medical_tokubetsu_kanri_add != 1 ||
      this.receiptVisitRecord.medical_leave_inst_flg != 1 ||
      this.baseDisableCheck()
    ) {
      result = true;
    }
    return result;
  }

  // 特別管理指導（指導１） 退院時共同指導日１の登録が前提
  protected disableCheckSpecialInstFlg1(): boolean {
    return (
      this.disableCheckSpecialInstFlg() ||
      !this.receiptVisitRecord.medical_leave_inst_date
    );
  }

  // 特別管理指導（指導２） 退院時共同指導日２の登録が前提
  protected disableCheckSpecialInstFlg2(): boolean {
    return (
      this.disableCheckSpecialInstFlg() ||
      !this.receiptVisitRecord.medical_leave_inst_date2
    );
  }

  // 退院支援指導
  protected disableCheckLeaveSupportFlg(): boolean {
    let result = false;
    if (
      !(this.isBeppyo7() || this.isBeppyo8() || this.event.indicate?.leave_support_visit_flg == 1) ||
      this.baseDisableCheck() ||
      this.officeHistory.business_div == 3
    ) {
      result = true;
    }
    return result;
  }

  // 登録時に、disabledの項目は0にする
  public clearDisableItemV5() {
    //提供時間
    if (this.disableCheckMedicalTimeZoneDivV2()) {
      this.receiptVisitRecord.medical_time_zone_div = 0;
    }
    //複数回訪問:回数
    if (this.disableCheckTimesDivV4()) {
      this.times_div2 = false;
      this.times_div3 = false;
      this.receiptVisitRecord.times_div = 0;
    }
    //複数回訪問:同一建物内（保存時のみ0にする特殊ケース）
    if (this.disableCheckTimesSameBuildingDiv()) {
      this.receiptVisitRecord.times_threeperson_div = 0;
    }
    //複数名訪問:職員種別
    if (this.disableCheckAccompaniedStaffDivV2()) {
      this.receiptVisitRecord.accompanied_staff_div = 0;
    }
    //複数名訪問:（ニ）（ハ）
    if (this.disableCheckAccompaniedHojoStaffDivV5()) {
      this.receiptVisitRecord.accompanied_hojo_staff_div = 0;
    }
    //複数名訪問:回数区分
    if (this.disableCheckAccompaniedStaffCntV5()) {
      this.accompanied_staff_cnt1 = false;
      this.accompanied_staff_cnt2 = false;
      this.accompanied_staff_cnt3 = false;
      this.receiptVisitRecord.accompanied_staff_cnt = 0;
    }
    //複数名訪問:同一建物内（保存時のみ0にする特殊ケース）
    if (this.disableCheckAccompaniedStaffSameBuildingDiv()) {
      this.receiptVisitRecord.accompanied_staff_threeperson_div = 0;
    }
    //機能強化型訪問看護管理療養費1
    if (
      this.disableCheckKinouKyokaDiv1V2() &&
      !this.kinou_kyoka_div2 &&
      !this.kinou_kyoka_div3 &&
      !this.kinou_kyoka_div4
    ) {
      this.kinou_kyoka_div1 = false;
      this.receiptVisitRecord.kinou_kyoka_div = 0;
    }
    //機能強化型訪問看護管理療養費2
    if (
      this.disableCheckKinouKyokaDiv2V2() &&
      !this.kinou_kyoka_div1 &&
      !this.kinou_kyoka_div3 &&
      !this.kinou_kyoka_div4
    ) {
      this.kinou_kyoka_div2 = false;
      this.receiptVisitRecord.kinou_kyoka_div = 0;
    }
    //機能強化型訪問看護管理療養費3
    if (
      this.disableCheckKinouKyokaDiv3V2() &&
      !this.kinou_kyoka_div1 &&
      !this.kinou_kyoka_div2 &&
      !this.kinou_kyoka_div4
    ) {
      this.kinou_kyoka_div3 = false;
      this.receiptVisitRecord.kinou_kyoka_div = 0;
    }
    //機能強化型訪問看護管理療養費4
    if (
      this.disableCheckKinouKyokaDiv4() &&
      !this.kinou_kyoka_div1 &&
      !this.kinou_kyoka_div2 &&
      !this.kinou_kyoka_div3
    ) {
      this.kinou_kyoka_div4 = false;
      this.receiptVisitRecord.kinou_kyoka_div = 0;
    }
    //退院時共同指導
    if (this.disableCheckMedicalLeaveInstFlg()) {
      this.receiptVisitRecord.medical_leave_inst_flg = 0;
      this.receiptVisitRecord.medical_leave_inst_staff_div = 0;
    }
    //退院時共同指導日（無効時はクリア）
    if (this.disableCheckMedicalLeaveInstDate()) {
      this.receiptVisitRecord.medical_leave_inst_date = "";
      this.receiptVisitRecord.medical_leave_inst_date2 = "";
    }
    //別表7/8非該当時は退院時共同指導日2を登録しない
    if (!(this.isBeppyo7() || this.isBeppyo8())) {
      this.receiptVisitRecord.medical_leave_inst_date2 = "";
    }
    //特別管理指導
    if (this.disableCheckSpecialInstFlg1()) {
      this.special_inst_flg1 = false;
    }
    if (this.disableCheckSpecialInstFlg2()) {
      this.special_inst_flg2 = false;
    }
    this.applySpecialInstFlg();
    //退院支援指導
    if (this.disableCheckLeaveSupportFlg()) {
      this.receiptVisitRecord.leave_support_flg = 0;
      this.receiptVisitRecord.leave_support_staff_div = 0;
    }
    //退院日
    if (this.disableCheckLeaveSupportDate()) {
      this.receiptVisitRecord.leave_support_date = "";
    }
  }
}
